
import { useEffect, useState } from 'react'
import AddUpdateEmployee from './employee'
import Style from './style.module.css'
import LeftSidePopupLayout from '../modal-layout'
import AddUpdateNotice from './notice'
import { useApiCall } from '../../custom-hooks/api-call'
import { Bell, BriefcaseBusiness, Clock, Plus, Upload, X, XIcon } from 'lucide-react'
import AddUpdateJob from './job'
import AddUpdatePPC from './ppc'
import UploadPPC from './ppc/upload-ppc'





const MainPopup = ({ onClose = () => { }, onChange = () => { }, onSuccess = () => { }, onError = () => { }, tabIndex, data }) => {
    const [navIndex, setNavIndex] = useState(tabIndex || 0);
    const navItems = [
        { label: `${data ? "Update" : "Add"} PPC`, icon: <Plus size="1.2em" /> },
        { label: "Upload Excel", icon: <Upload size="1.2em" /> },
    ];

    const handleNavClick = (index) => {
        setNavIndex(index);
        console.log("index", index)
    };

    return (
        <>
            <div className={Style.modal_body}>
                <LeftSidePopupLayout overlayClassName={"!justify-center items-center"} popupStatus={true} className={Style.departmentChangeModal}>
                    <div className={Style.modal_header} style={{backgroundColor: "white"}}>
                        <div className={Style.modal_nav}>
                            <ul>
                                {navItems.map((item, i) => (
                                    <li
                                        key={i}
                                        className={`${navIndex === i ? Style.active : ""} ${((tabIndex || tabIndex == 0) && navIndex !== i) ? Style.disabled : ""}`}
                                        onClick={() => {
                                            console.log("tabIndextabIndex", tabIndex)
                                            if (tabIndex) {
                                                if (!navIndex === i) {
                                                    handleNavClick(i);
                                                }
                                            } else {
                                                handleNavClick(i);
                                            }
                                        }}
                                    >
                                        <div className={Style.icon}>{item.icon}</div>
                                        <span>{item.label}</span>
                                    </li>
                                ))}
                            </ul>
                        </div>
                        <div className={`flex items-center gap-2 ${Style.close_btn}`}>
                            <button
                                className="inline-flex items-center gap-1.5 rounded-xl bg-[#0B54FF] px-3 py-2 text-sm font-medium text-white hover:bg-[#0849e0]"
                                onClick={onClose}
                                aria-label="Close"
                            >
                                <X className="size-4" />
                            </button>
                        </div>
                    </div>
                    {navIndex == 0 &&
                        <AddUpdatePPC
                            onClose={() => { onClose() }}
                            onChange={() => { onChange() }}
                            Style={Style}
                            data={data}
                            onSuccess={onSuccess}
                            onError={onError}
                        />
                    }

                    {navIndex == 1 &&
                        <UploadPPC 
                            onClose={() => { onClose() }}
                            onChange={() => { onChange() }}
                            Style={Style}
                            data={data}
                            onSuccess={onSuccess}
                            onError={onError}
                        />
                    }
                </LeftSidePopupLayout>
            </div>
        </>
    )
}

export default MainPopup
